import { Tooltip, withStyles } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import InfoIcon from '@material-ui/icons/Info'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import {
  CART_TOOLTIP_DISCOVERY,
  CART_TOOLTIP_PRESCHOOL,
  CART_TOOLTIP_SUBSCRIPTION
} from 'app/pages/Class/Inventory/constants'
import { formatAmountIndian } from 'app/utils'
import CoinIcon from 'assets/images/coin.png'

import * as Styles from './styles'

import { transformCartItem } from '../../../../../helpers'

const CustomTooltip = withStyles({
  tooltip: {
    color: 'while',
    fontSize: '14px',
    backgroundColor: 'rgba(0,0,0,0.85)',
    padding: '10px'
  }
})(Tooltip)

const CartItem = ({ item, onEdit, onDelete }) => {
  const {
    subjectName,
    subjectImage,
    batchLevel,
    bookingType,
    batchTimings,
    startDate,
    endDate,
    paymentCycle,
    price,
    isPriceUpdated,
    additionalDiscount
  } = transformCartItem(item)

  const isSchoolOrCare = bookingType === 'school' || bookingType === 'care'
  const showPrice = isSchoolOrCare ? isPriceUpdated : true
  return (
    <Styles.ItemContainer>
      <Styles.CourseContainer>
        <Styles.CourseIcon src={subjectImage} alt={subjectName} />
        <Styles.CourseDetails>
          <Styles.CourseName>{subjectName}</Styles.CourseName>
          <Styles.CourseType>
            {isSchoolOrCare ? paymentCycle?.label : bookingType}
          </Styles.CourseType>
        </Styles.CourseDetails>
        <Styles.ActionButtons>
          {/* <Styles.IconButtonLeft onClick={() => onEdit(item)}> */}
          {/* <EditIcon /> */}
          {/* </Styles.IconButtonLeft> */}
          <Styles.IconButtonRight onClick={() => onDelete(item)}>
            <DeleteIcon />
          </Styles.IconButtonRight>
        </Styles.ActionButtons>
      </Styles.CourseContainer>

      <Styles.InfoGrid>
        {!isSchoolOrCare && (
          <Styles.InfoItem>
            <Styles.InfoLabel>Level</Styles.InfoLabel>
            <Styles.InfoValue>
              {batchLevel ? batchLevel : 'N/A'}
            </Styles.InfoValue>
          </Styles.InfoItem>
        )}
        <Styles.InfoItem>
          <Styles.InfoLabel>Batch Timings</Styles.InfoLabel>
          <Styles.InfoValue>{batchTimings}</Styles.InfoValue>
        </Styles.InfoItem>
        <Styles.InfoItem>
          <Styles.InfoLabel>Start Date</Styles.InfoLabel>
          <Styles.InfoValue>{startDate}</Styles.InfoValue>
        </Styles.InfoItem>
        {bookingType === 'Discovery' && (
          <Styles.InfoItem>
            <Styles.InfoLabel>End Date</Styles.InfoLabel>
            <Styles.InfoValue>{endDate}</Styles.InfoValue>
          </Styles.InfoItem>
        )}
      </Styles.InfoGrid>

      {showPrice && (
        <Styles.PriceContainer>
          <Styles.PriceLabelContainer>
            <Styles.PriceLabel>{`Price${
              !isEmpty(additionalDiscount) ? '*' : ''
            }`}</Styles.PriceLabel>
            {!isEmpty(additionalDiscount) ? (
              <Styles.PriceSubLabel>
                *additional discount applied
              </Styles.PriceSubLabel>
            ) : null}
          </Styles.PriceLabelContainer>
          <Styles.Price>
            {!isSchoolOrCare && <Styles.CoinImage src={CoinIcon} alt="Coin" />}
            {isSchoolOrCare ? formatAmountIndian(price) : price}
            <CustomTooltip
              arrow
              placement="top-end"
              title={
                isSchoolOrCare
                  ? CART_TOOLTIP_PRESCHOOL
                  : bookingType === 'Discovery'
                  ? CART_TOOLTIP_DISCOVERY
                  : CART_TOOLTIP_SUBSCRIPTION
              }
            >
              <InfoIcon
                style={{ color: 'rgba(0, 0, 0, 0.36)', width: 14 }}
                color="rgba(0, 0, 0, 0.36)"
              />
            </CustomTooltip>
          </Styles.Price>
        </Styles.PriceContainer>
      )}
    </Styles.ItemContainer>
  )
}

export default CartItem
